import React, { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { Button } from "./ui/button";

export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("pwa_install_dismissed") === "1") return;
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const ios = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    if (ios) {
      setIsIOS(true);
      setShow(true);
    }
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("pwa_install_dismissed", "1");
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    dismiss();
  };

  if (!show) return null;

  return (
    <div
      className="fixed z-40 left-3 right-3 bottom-24 lg:left-auto lg:right-6 lg:bottom-6 lg:w-[22rem]"
      data-testid="install-prompt"
    >
      <div className="bg-white rounded-2xl border border-slate-100 shadow-xl shadow-blue-900/10 p-4 flex items-start gap-3">
        <img
          src={`${process.env.PUBLIC_URL}/icon-192.png`}
          alt="Iridescent"
          className="h-12 w-12 rounded-xl shrink-0"
        />
        <div className="flex-1">
          <p className="font-heading text-ink font-medium text-sm">Install the Iridescent app</p>
          {isIOS ? (
            <p className="text-xs text-[#5C6664] mt-1">
              Tap <Share className="inline h-3 w-3 -mt-0.5" /> Share, then “Add to Home Screen” for
              one-tap check-in &amp; rewards.
            </p>
          ) : (
            <p className="text-xs text-[#5C6664] mt-1">
              Add us to your home screen for one-tap check-in, rewards and booking.
            </p>
          )}
          {!isIOS && (
            <Button
              onClick={install}
              data-testid="install-app-button"
              className="mt-3 iri-gradient text-ink rounded-full h-9 text-sm px-5 hover:opacity-90 transition-opacity"
            >
              <Download className="h-4 w-4 mr-1.5" /> Install app
            </Button>
          )}
        </div>
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          data-testid="install-dismiss"
          className="text-[#8A9492] hover:text-ink transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
